// MenuBar menu items config
export const MENU_ITEMS = ['File', 'Agents', 'Skills', 'Cloud', 'Window', 'Help'] as const
export type MenuItem = typeof MENU_ITEMS[number]
